import React, {useState,useEffect} from 'react'
import { motion } from 'framer-motion';
import { 
  SearchOutlined, 
  DownloadOutlined, 
  SortAscendingOutlined, 
  SortDescendingOutlined,
  LeftOutlined,
  RightOutlined,
  CalendarOutlined
} from '@ant-design/icons';
import { Button, Tooltip, Input, Pagination, Popover, DatePicker } from 'antd';
import moment from 'moment';

import './ClientView.css';
import ClientDetailModal from './ClientDetailModal';

const { MonthPicker } = DatePicker;

function ClientView({isrTargetAchieved,selectedPod,loading,currentUser,clientData,targetMetrics,currentMonth,modality,setCurrentMonth}) {

    const [mappedClientData,setMappedClientData] = useState([])
    const [podClientData,setPodClientData] = useState([])
    const [othersClientData,setOthersClientData] = useState({})
    const [searchTerm, setSearchTerm] = useState('');
    const [sortField, setSortField] = useState('caseCount');
    const [sortDirection, setSortDirection] = useState('desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [clientModalVisible, setClientModalVisible] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    // const [currentMonth, setCurrentMonth] = useState(moment());

    useEffect(()=>{
        setPodClientData([])
        setOthersClientData({})
        if(clientData?.length>0){
           processPodData()
        }
    },[clientData,targetMetrics])

    useEffect(() => {
        setCurrentPage(1);
    }, [selectedPod]);

    // Function to process and match pincodes
    const processPodData = () => {
        // Initialize data structure for each pod
        // setOthersData({})
        // setPodData([])
        // setPodData([])

        // ////console.log(clientData,'clientData')
        
        const processedPodData = targetMetrics?.map(pod => ({
            pod_id: pod?.pod_fk,
            pod_name: pod?.name,
            total: 0,
            client_data: []
        }));
        // ////console.log(targetMetrics,'targetMetrics')
        // ////console.log(processedPodData,'processedPodData')
        // Initialize others category
        const others = {
            total: 0,
            client_data: []
        };

        // return

        // console.log(clientData)
        
        // Process each case count entry
        console.log(clientData,'clientData')
        clientData?.forEach(caseData => {
            const caseCount = parseInt(caseData?.case_count) || 0;
            const casePincode = caseData?.pincode;
            const client_name = caseData?.client_name;
            const client_fk = caseData?.client_id;
            const incentive_amount = caseData?.incentive_amount;
            const modalities = caseData?.modalities;
            
            // Skip if no pincode (or handle as needed)
            if (!client_fk) {
                // Add to others or handle null pincodes as needed
                others.total += caseCount;
                others.client_data.push({client_name,client_fk,caseCount,incentive_amount,modalities})
                return;
            }
            
            // Find matching pod
            let matchFound = false;
            
            for (let i = 0; i < targetMetrics?.length; i++) {
                const pod = targetMetrics?.[i];
                const podClients = pod?.client_ids ? pod?.client_ids?.split(',').map(p => p.trim()) : [];
                
                // Check if case pincode is in pod's pincode list
                if (podClients.includes(client_fk)) {
                    // Add to pod total
                    processedPodData[i].total += caseCount;
                    
                    processedPodData[i].client_data.push({client_name,client_fk,caseCount,incentive_amount,modalities})

                    matchFound = true;
                    break;
                }
            }
            
            // If no matching pod found, add to others
            if (!matchFound) {
                others.total += caseCount;
                others.client_data.push({client_name,client_fk,caseCount,incentive_amount,modalities})
                others.name = 'Others'
            }
        });
        
        // Update state with processed data
        console.log(processedPodData,'processedPodData')
        setPodClientData(processedPodData);
        //console.log(others,'others')
        setOthersClientData(others);
    };

    if (loading) {
        return (
            <div className="client-view-container">
                <div className="client-view-loading">
                    <div className="shimmer-client-search"></div>
                    <div className="shimmer-client-table"></div>
                    <div className="shimmer-client-pagination"></div>
                </div>
            </div>
        );
    }
    
    // Find the selected pod's data

    let selectedPodData ={}
    if(selectedPod?.name!='Others'){
        selectedPodData = podClientData?.find(pod => pod.pod_name === selectedPod?.name);
    }else{
        selectedPodData = othersClientData
    }
   

    if (!selectedPodData || !selectedPodData?.client_data || selectedPodData?.client_data?.length === 0) {
        return (
            <div className="client-view-container">
                <div className="no-data-message">
                    No client data available for {selectedPod?.name || 'the selected pod'}.
                </div>
            </div>
        );
    }
    
    // Format client data from the structure shown in the console
    const clientList = selectedPodData?.client_data?.map(client => ({
        name: client.client_name,
        id: client.client_fk,
        caseCount: client.caseCount || 0,
        incentive_amount: client.incentive_amount || 0,
        modalities: client.modalities || {},
        // You can add more fields here if available in your data
    }));
    // return
    // Filter by search term
    const filteredClients = clientList?.filter(client => 
        client.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        client.id.toString().includes(searchTerm)
    );
    
    // Sort the filtered clients
    const sortedClients = [...filteredClients]?.sort((a, b) => {
        const factor = sortDirection === 'asc' ? 1 : -1;
        
        if (sortField === 'name') {
            return factor * a.name.localeCompare(b.name);
        } else if (sortField === 'id') {
            return factor * a.id.localeCompare(b.id);
        } else {
            return factor * (a[sortField] - b[sortField]);
        }
    });
    
    // Paginate the sorted clients
    const paginatedClients = sortedClients?.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );
    
    // Handle sort change
    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDirection('desc');
        }
    };
    
    // // Export to CSV
    const exportToCSV = () => {
        const headers = ['Client Name', 'Client ID', 'Case Count'];
        const dataRows = sortedClients?.map(client => [
            client.name,
            client.id,
            client.caseCount
        ]);
        
        const csvContent = [
            headers.join(','),
            ...dataRows.map(row => row.join(','))
        ].join('\n');
        
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `${selectedPod}_client_data.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Handle client row click
    const handleClientClick = (client) => {
        setSelectedClient(client);
        setClientModalVisible(true);
    };

    // Update month change handler
    const handleMonthChange = (date) => {
        setCurrentMonth(date);
    };

    // Month navigation functions
    const prevMonth = () => {
        setCurrentMonth(currentMonth.clone().subtract(1, 'month'));
    };
    
    const nextMonth = () => {
        setCurrentMonth(currentMonth.clone().add(1, 'month'));
    };

    const goToCurrentMonth = () => {
        setCurrentMonth(moment());
    };

    return (
        <div className="client-view-container">
            <div className="client-view-header">
                <div className="header-left">
                    
                    <div className="search-container">
                        <Input
                            placeholder="Search by client name or ID..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            prefix={<SearchOutlined />}
                            allowClear
                            className="client-search"
                        />
                    </div>
                </div>
                
                <div className="client-view-actions">
                <div className="month-navigation" style={{display:'flex',alignItems:'center',gap:'10px'}}>
                        <Button 
                            icon={<LeftOutlined />}
                            onClick={prevMonth}
                            className="month-nav-button"
                        />
                        {/* <DatePicker
                            picker="month"
                            value={currentMonth}
                            onChange={(date) => setCurrentMonth(date)}
                            allowClear={false}
                            className="month-picker"
                            format="MMMM YYYY"
                            suffixIcon={<CalendarOutlined />}
                        /> */}
                               <h2 className="current-month">{currentMonth.format('MMMM YYYY')}</h2>
                        <Button 
                            icon={<RightOutlined />}
                            onClick={nextMonth}
                            className="month-nav-button"
                        />
                        {/* <Button 
                            onClick={goToCurrentMonth}
                            className="month-nav-button today-button"
                        >
                            Today
                        </Button> */}
                    </div>
                    {/* <Tooltip title="Export to CSV">
                        <Button 
                            icon={<DownloadOutlined />} 
                            className="export-button"
                        >
                            Export
                        </Button>
                    </Tooltip> */}
                </div>
            </div>
            
            <div className="client-table">
                <div className="client-table-header">
                    <div 
                        className="client-header-cell client-name sortable"
                        onClick={() => handleSort('name')}
                    >
                        Client Name
                        {sortField === 'name' && (
                            sortDirection === 'asc' 
                                ? <SortAscendingOutlined className="sort-icon" /> 
                                : <SortDescendingOutlined className="sort-icon" />
                        )}
                    </div>
                    {/* <div 
                        className="client-header-cell client-id sortable"
                        onClick={() => handleSort('id')}
                    >
                        Client ID
                        {sortField === 'id' && (
                            sortDirection === 'asc' 
                                ? <SortAscendingOutlined className="sort-icon" /> 
                                : <SortDescendingOutlined className="sort-icon" />
                        )}
                    </div> */}
                    <div className="client-header-cell client-XRAY">XRAY</div>
                    <div className="client-header-cell client-CT">CT</div>
                    <div className="client-header-cell client-MRI">MRI</div>
                    <div className="client-header-cell client-NM">NM</div>
                    <div 
                        className="client-header-cell client-count sortable"
                        onClick={() => handleSort('caseCount')}
                    >
                        Case Count
                        {sortField === 'caseCount' && (
                            sortDirection === 'asc' 
                                ? <SortAscendingOutlined className="sort-icon" /> 
                                : <SortDescendingOutlined className="sort-icon" />
                        )}
                    </div>
                    <div className="client-header-cell client-view-details">View Details</div>
                </div>
                
                <div className="clients-table-body">
                    {paginatedClients.length > 0 ? (
                        paginatedClients.map((client, index) => (
                            <motion.div 
                                key={client.id}
                                className="client-row"
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3, delay: index * 0.03 }}
                                onClick={() => handleClientClick(client)}
                            >
                                <div className="client-cell client-name">{client.name}</div>
                                {/* <div className="client-cell client-id">{client.id}</div> */}
                                <div className="client-cell client-XRAY">
                                    <div style={{fontSize:'12px',color:'#000'}}>₹ {isrTargetAchieved>0 ? <> {client.modalities?.XRAY?.amount}</> : 0}</div>
                                    <div style={{fontSize:'10px',color:'#000'}}>({client.modalities?.XRAY?.total})</div>
                                 
                                </div>
                                <div className="client-cell client-CT">
                                    <div style={{fontSize:'12px',color:'#000'}}>₹ {isrTargetAchieved>0 ? <> {client.modalities?.CT?.amount}</> : 0}</div>
                                    <div style={{fontSize:'10px',color:'#000'}}>({client.modalities?.CT?.total})</div>
                                </div>
                                <div className="client-cell client-MRI">
                                    <div style={{fontSize:'12px',color:'#000'}}>₹ {isrTargetAchieved>0 ? <> {client.modalities?.MRI?.amount}</> : 0}</div>
                                    <div style={{fontSize:'10px',color:'#000'}}>({client.modalities?.MRI?.total})</div>
                                </div>
                                <div className="client-cell client-NM">
                                    <div style={{fontSize:'12px',color:'#000'}}>₹ {isrTargetAchieved>0 ? <> {client.modalities?.NM?.amount}</> : 0}</div>
                                    <div style={{fontSize:'10px',color:'#000'}}>({client.modalities?.NM?.total})</div>
                                </div>
                                <div className="client-cell client-count">
                                    <div style={{fontSize:'12px',color:'#000'}}>₹ {isrTargetAchieved>0 ? <> {client.modalities?.XRAY?.amount+client.modalities?.CT?.amount+client.modalities?.MRI?.amount+client.modalities?.NM?.amount}</> : 0}</div>
                                    <div style={{fontSize:'10px',color:'#000'}}>({client.modalities?.XRAY?.total+client.modalities?.CT?.total+client.modalities?.MRI?.total+client.modalities?.NM?.total})</div>
                                </div>
                                <div>
                                                        <Popover
                                title="Modality Breakdown"
                                content={
                                    <div className="modality-breakdown">
                                    {Object.entries(client.modalities).map(([modalityName, modalityData]) => {
                                        if (modalityData.total > 0) {
                                        return (
                                            <div key={modalityName} className="modality-section">
                                            <div className="modality-header">
                                                <span className={`modality-name ${modalityName.toLowerCase()}`}>
                                                {modalityName}
                                                </span>
                                                <span>Total: {modalityData.total}</span>
                                            </div>
                                            <div className="discount-splits">
                                                {Object.entries(modalityData.splits).map(([discount, count]) => {
                                                if (discount !== 'incentive_amount' && count > 0) {
                                                    return (
                                                    <div key={discount} className="discount-row">
                                                        <span>{discount}</span>
                                                        <span>{count} cases</span>
                                                        <span>₹{isrTargetAchieved>0 ? <> {modalityData.splits.incentive_amount[discount]}</> : 0}</span>
                                                    </div>
                                                    );
                                                }
                                                return null;
                                                })}
                                            </div>
                                            </div>
                                        );
                                        }
                                        return null;
                                    })}
                                    </div>
                                }
                                >
                                <Button type="link">View Details</Button>
                                </Popover>
                                </div>
                            </motion.div>
                        ))
                    ) : (
                        <div className="no-data-row">
                            {searchTerm ? 'No clients match your search' : 'No client data available'}
                        </div>
                    )}
                </div>
            </div>
            
            <div className="client-pagination">
                <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={filteredClients.length}
                    onChange={setCurrentPage}
                    showSizeChanger
                    onShowSizeChange={(current, size) => {
                        setPageSize(size);
                        setCurrentPage(1);
                    }}
                    pageSizeOptions={['10', '20', '50', '100']}
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} clients`}
                />
            </div>
            
            <div className="client-summary">
                <div className="summary-item">
                    <div className="summary-label">Total Clients</div>
                    <div className="summary-value">{clientList.length}</div>
                </div>
                <div className="summary-item">
                    <div className="summary-label">Total Cases</div>
                    <div className="summary-value">
                        {clientList.reduce((sum, client) => sum + client.caseCount, 0)}
                    </div>
                  
                </div>
                <div className="summary-item">
                    <div className="summary-label">Total Amount</div>
                    <div className="summary-value">₹ {isrTargetAchieved>0 ? <> {clientList.reduce((sum, client) => sum + client.incentive_amount, 0)}</> : 0}</div>
                </div>
                <div className="summary-item">
                    <div className="summary-label">Cross Section</div>
                    <div className="summary-value">{clientList.reduce((sum, client) => sum +  (client?.modalities?.CT?.total||0) + (client?.modalities?.MRI?.total||0) , 0)}</div>
                </div>
            </div>
            
            {/* Client Detail Modal */}
            {selectedClient && (
                <ClientDetailModal
                    visible={clientModalVisible}
                    onClose={() => setClientModalVisible(false)}
                    clientId={selectedClient.id}
                    clientName={selectedClient.name}
                    podName={selectedPod}
                    currentUser={currentUser}
                    targetMetrics={targetMetrics}
                    currentMonth={currentMonth}
                    modality={modality}
                    isrTargetAchieved={isrTargetAchieved}
                />
            )}
        </div>
    )
}

export default ClientView
